import {gql} from '@apollo/client';

/**
 * 客诉状态字典（code + 可扩展多语言文案 texts）
 *
 * 后端单一来源：swiftx-delivery-service ComplaintStatus enum 上挂的 texts({lang:text}) 映射。
 * texts 结构与 complaintReason/appealReason/reviewComment 的 translations 一致（[{lang,text}]），
 * 前端按当前 locale 从 texts 取（pickDisplayText 同款逻辑）。新增语言后端枚举 texts 加一项即可，前端不改。
 */
export const GET_COMPLAINT_STATUS_LIST = gql`
    query GetComplaintStatusList {
        getComplaintStatusList {
            code
            texts {
                lang
                text
            }
        }
    }
`;

export interface ComplaintStatusOption {
    code: string;
    texts: {lang: string; text: string}[];
}

export interface GetComplaintStatusListResponse {
    getComplaintStatusList: ComplaintStatusOption[];
}
